export default function HorizontalDotsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      fill="none"
      viewBox="0 0 31 30"
    >
      <path
        fill="#333"
        d="M7 15.532a1.532 1.532 0 103.063 0 1.532 1.532 0 00-3.063 0zm7.658 0a1.532 1.532 0 103.064 0 1.532 1.532 0 00-3.064 0zm7.659 0a1.531 1.531 0 103.062 0 1.531 1.531 0 00-3.062 0z"
      ></path>
    </svg>
  );
}
